import AccountsPage from "../../pages/dashboard/accounts/AccountsPage";

export const AccountsRoutes = [
  {
    name: "Tài khoản",
    path: "",
    element: <AccountsPage />,
  },
];
